<div class="dropdown-box">
   <div class="dropdown">
      <button
         id="{{ this._internalId }}"
         class="btn btn-secondary dropdown-toggle"
         type="button"
         data-toggle="dropdown"
         aria-haspopup="true"
         aria-expanded="false">
         {{ selectedItemId() && selectedItem() ? selectedItem()[textSelector()] : defaultLabel() }}
      </button>
      <div
         class="dropdown-menu"
         [attr.aria-labelledby]="this._internalId">
         @for (e of items(); track e[idSelector()]) {
         <a
            class="dropdown-item"
            href="javascript:void(0)"
            (click)="onItemSelected(e)">
            {{ e[textSelector()] }}
         </a>
         }
      </div>
   </div>
</div>
